import React, { useState } from 'react';
import { useHistory, useLocation, Link } from "react-router-dom";
import { Layout, Menu, Image, Space, Button, Row, Col, Grid, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Logo from '../../../assets/img/WCHSS.png';
import ArchiveDropdown from './ArchiveDropdown';
import { archives } from '../../../config/archives';
const { useBreakpoint } = Grid;
const { Header } = Layout;

function Headers() {
  const [visible, setVisible] = useState(false);
  
  let history = useHistory()
  let location = useLocation()
  let { xs, xxl } = useBreakpoint()

  const registrationPath = '/wchss-2026/registration';
  
  const handleMenu = (e) => {
    const key = String(e?.key ?? '');

    if (!key || key === '/archive' || key.startsWith('/archive/')) {
      setVisible(false);
      return;
    }

    if (/^https?:\/\//.test(key)) {
      setVisible(false);
      return;
    }

    history.push(key);
    setVisible(false);
  }

  const showDrawer = () => {
    setVisible(true)
  };

  const onClose = () => {
    setVisible(false)
  };
  
  const navItems = [
    { label: 'Home', key: '/' },
    { label: 'About', key: '/about' },
    { label: 'Call For Papers', key: '/call-for-papers' },
    { label: 'Sponsorship', key: '/sponsorship' },
    { label: 'Publications', key: '/publications' },
    { label: 'Contact Us', key: '/contact-us' },
    { label: 'Registration', key: registrationPath },
  ];

  const selectedKeys = [
    location.pathname,
    `${location.pathname}${location.search || ''}`,
  ].filter(Boolean);
  
  return (
    <Header className='header' style={{ height: 80, boxShadow: location.pathname === '/' ? null : '1px 4px 4px 1px #f2f2f2' }}>
      <Row justify="space-around" align="middle" style={{ padding: xxl ? '0 230px' : 0, margin: 0 }}>
        <Col xxl={2} lg={4} xs={8}>
          <Image
            width={'100%'}
            src={ Logo }
            preview={false}
          />
        </Col>
        <Col xxl={20} lg={20} xs={16}>
          {
            xs ?
              <Space style={{ float: 'right' }}>
                <Link to={registrationPath}>
                  <Button className='button-registration'>Registration</Button>
                </Link>
                <Button size='large' icon={<MenuOutlined />} onClick={showDrawer} style={{ borderRadius: 4 }} />
              </Space>
            :
              <Space style={{ float: 'right' }}>
                <Menu
                  mode="horizontal"
                  defaultSelectedKeys={['/']}
                  selectedKeys={selectedKeys}
                  onClick={handleMenu}
                  style={{ height: 80, paddingTop: 8 }}
                >
                  {navItems.map((item) => (
                    <Menu.Item key={item.key}>{item.label}</Menu.Item>
                  ))}
                  <ArchiveDropdown archives={archives} onClose={() => setVisible(false)} />
                </Menu>
                <Link to={registrationPath}>
                  <Button className='button-registration'>Registration</Button>
                </Link>
              </Space>

          }
        </Col>
      </Row>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={'50%'}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          defaultSelectedKeys={['/']}
          selectedKeys={selectedKeys}
          onClick={handleMenu}
        >
          {navItems.map((item) => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
          <ArchiveDropdown archives={archives} onClose={() => setVisible(false)} />
        </Menu>
      </Drawer>
    </Header>
  )
}

export default Headers